import React from 'react';
import InviteUser from 'components/InviteUser';
import {FormattedMessage} from 'react-intl';
import './NoResultsInvitePrompt.css';

const NoResultsInvitePrompt = ({onOpen, onSend}) => (
  <div className="NoResultsInvitePrompt">
    <div className="NoResultsInvitePrompt__Title">
      <FormattedMessage
        id="NoResultsInvitePrompt__Title"
        defaultMessage="No Results"
        description="Displayed to indicate their search query has no results."
      />
    </div>
    <div className="NoResultsInvitePrompt__Text">
      <FormattedMessage
        id="NoResultsInvitePrompt__Text"
        defaultMessage="Can't find someone? Invite them to Domo."
        description="Suggestion to invite a new user to Domo"
      />
    </div>
    <InviteUser onOpen={onOpen} onSend={onSend} />
  </div>
);
export default NoResultsInvitePrompt;
